// Teacher → Classes grid. Each class links to its roster. R9.

import { useT } from '@fajrarabi/i18n/react';
import { Card, CardBody, Skeleton } from '@fajrarabi/ui';
import { useQuery } from '@tanstack/react-query';
import { Link, createFileRoute, useParams } from '@tanstack/react-router';

import { asLocale } from '~/lib/locale';
import { listTeacherClasses } from '~/lib/school';

export const Route = createFileRoute('/$locale/teacher/classes')({
  component: TeacherClassesScreen,
});

function TeacherClassesScreen() {
  const t = useT();
  const { locale: rawLocale } = useParams({ from: '/$locale' });
  const locale = asLocale(rawLocale);
  const classes = useQuery({
    queryKey: ['teacher', 'classes'],
    queryFn: ({ signal }) => listTeacherClasses(signal),
  });

  return (
    <div className="mx-auto max-w-4xl px-6 py-10">
      <h1 className="text-2xl font-bold text-ink-900">{t('app.teacher.classes_title')}</h1>

      {classes.isLoading ? (
        <Skeleton className="mt-6 h-24 w-full" />
      ) : (classes.data?.length ?? 0) === 0 ? (
        <Card className="mt-6">
          <CardBody>
            <p className="text-sm text-ink-700">{t('app.teacher.no_classes')}</p>
          </CardBody>
        </Card>
      ) : (
        <div className="mt-6 grid gap-4 sm:grid-cols-2">
          {classes.data!.map((cls) => (
            <Link
              key={cls.id}
              to="/$locale/teacher/class/$classId"
              params={{ locale, classId: cls.id }}
              className="rounded-2xl bg-white p-5 shadow-[0_12px_30px_-20px_rgba(31,26,23,0.25)] ring-1 ring-burgundy-500/10 transition-shadow hover:shadow-[0_18px_40px_-22px_rgba(31,26,23,0.3)]"
            >
              <p className="text-lg font-bold text-ink-900">{cls.name}</p>
              <p className="mt-1 text-sm uppercase tracking-wide text-ink-500">{cls.grade}</p>
              <p className="mt-3 text-sm text-ink-700">
                {t('app.school.student_count', { n: cls.studentCount })}
              </p>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
